import React from 'react';

const ProgressBar = ({ percent, color }) => {
  return (
    <div className="flex items-center gap-x-3">
      <div className="w-full flex-grow bg-gray-200 rounded-full h-1.5">
        <div
          className="h-1.5 rounded-full"
          style={{
            width: `${percent}%`,
            backgroundColor: color
          }}
        />
      </div>
      <div className="w-8 text-right text-sm font-medium text-gray-600">
        {percent}%
      </div>
    </div>
  );
};

export default ProgressBar;
